<template>
  <router-link
    v-if="item.type === 'router-link'"
    :to="item.action"
    :class="item.classNames">
    <tt-avatar v-if="item.hasAvatar"
               :own="true"
               class="b-header__nav-avatar" />
    <company-avatar v-if="item.hasLogo"
                    :own="true"
                    class="b-header__nav-logo" />
    {{ item.name }}
  </router-link>
  <button v-else-if="item.type === 'button'"
          :class="item.classNames"
          @click="$emit('action', item.action)">
    {{ item.name }}
  </button>
  <a v-else-if="item.type === 'link'"
     :href="item.href"
     :class="item.classNames">
    {{ item.name }}
  </a>
  <language-selector v-else-if="item.type === 'subnav-lang-selector'" />
</template>

<script>
  import LanguageSelector from '@/components/dashboard_components/LanguageSelector';

  export default {
    components: {
      'language-selector': LanguageSelector
    },
    props: {
      item: {
        type: Object,
        default() {
          return {};
        }
      }
    },
  };
</script>
